import Typography from "@material-ui/core/Typography"
import { UserViewModel } from "../../api/user"
import ChangePasswordDialog from "./ChangePasswordDialog"
import { useTranslations } from "./use-translations"

const UserPasswordSetting = ({ user }: { user: UserViewModel }) => {
  const translations = useTranslations()

  return (
    <>
      <Typography variant="subtitle1" style={{ marginBottom: 0 }}>
        {translations.password}
      </Typography>
      <Typography gutterBottom variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
        {translations.passwordHint}
      </Typography>
      <ChangePasswordDialog user={user} />
    </>
  )
}

export default UserPasswordSetting
